/* eslint-disable */
import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const sortByFirstName = (a, b) => {
  const lowerA = a.firstName.toLowerCase();
  const lowerB = b.firstName.toLowerCase();
  if (lowerA < lowerB) return -1;
  if (lowerA > lowerB) return 1;
  return 0;
};

const useStaff = (load = false) => {
  const { staff } = useSelector(state => state.staff);
  const errors = useSelector(state => state.errors.staff);
  const dispatch = useDispatch();

  const createStaffMember = async ({ payload }) => {
    await dispatch.staff.create({ payload });
  };

  const deleteStaffMember = async ({ id }) => {
    await dispatch.staff.delete({ id });
  };

  const updateStaffMember = async ({ payload }) => {
    await dispatch.staff.update({ payload });
  };

  useEffect(() => {
    if (load && staff.length === 0) {
      dispatch.staff.load();
    }
  }, []);

  return {
    createStaffMember,
    deleteStaffMember,
    updateStaffMember,
    staff: staff.sort(sortByFirstName),
    errors,
  };
};

export default useStaff;
